require('dotenv').config();

const NODE_ENV = process.env.REACT_APP_NODE_ENV;

let baseUrl;

if (NODE_ENV === 'DEV') {
  baseUrl = 'http://localhost:3333';
} else if (NODE_ENV === 'PROD') {
  baseUrl = 'http://189.112.226.76:3333';
}

export default baseUrl;
